import React, { useEffect, useState } from "react";
import { useSocket } from "../context/SocketContext";
import { useNavigate } from "react-router-dom";
import roomBackgrounds from "../assets/roomBackgrounds";

function RoomSelection() {
  
  useEffect(() => {
  // Set background on mount
  document.body.style.backgroundImage = `url(${roomBackgrounds.Default})`;
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundPosition = "center";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundAttachment = "fixed";

  // Cleanup on unmount
  return () => {
    document.body.style.backgroundImage = "none";
    document.body.style.backgroundColor = "black"; // fallback color
    document.body.style.backgroundSize = "";
    document.body.style.backgroundPosition = "";
    document.body.style.backgroundRepeat = "";
    document.body.style.backgroundAttachment = "";
  };
}, []);

  const [rooms, setRooms] = useState([]);
  const [message, setMessage] = useState("");
  const { socket } = useSocket();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const isAuthed = !!token;

  const GUILDHALL_ALLOWED = ['Tim', 'Phzoul', 'BarMaN', 'abominax', 'Hfxtenor', 'Marshraven'];

  useEffect(() => {
    if (!isAuthed) return;

    const fetchRooms = async () => {
      try {
        const res = await fetch("/api/rooms", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setRooms(data);
        } else {
          setMessage(`⚠️ ${data.error || "Could not fetch rooms"}`);
        }
      } catch (err) {
        setMessage("⚠️ Server error");
      }
    };

    fetchRooms();
  }, [isAuthed, token]);

  if (!isAuthed) {
    return <p>🚫 Not authorized. Please log in.</p>;
  }

  const handleJoin = async (roomName) => {
    try {
      const res = await fetch(`/api/rooms/join`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username, roomName }),
      });

      const data = await res.json();
      if (res.ok) {
        localStorage.setItem("room", roomName);

        if (socket?.connected) {
          console.log("🧩 Socket already connected:", socket.id);
          const displayName = localStorage.getItem("displayName") || username;

  socket.emit("join-room", {
    room: roomName,
    username,
    displayName,
  });
          navigate(`/chat/${roomName}`);
        } else {
          setMessage("⚠️ Socket not connected");
        }
      } else {
        setMessage(`❌ ${data.error || "Could not join room"}`);
      }
    } catch (err) {
      setMessage("⚠️ Failed to join room");
    }
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2 style={{ color: "white", textShadow: "1px 1px 2px black" }}>Select a Room</h2>

      {rooms.length === 0 ? <p style={{ color: "white" }}>Loading rooms...</p> : null}

      <ul style={{ listStyle: "none", padding: 0 }}>
        {rooms.map((room, idx) => {
          const isGuildhall = room.name === "Guildhall";
          const isLocked = room.locked === true;
          const blockedFromGuildhall = isGuildhall && !GUILDHALL_ALLOWED.includes(username);
          const disabled = isLocked || blockedFromGuildhall;

          return (
            <li
              key={room.id || idx}
              style={{
                margin: "1rem auto",
                maxWidth: "400px",
                padding: "1rem",
                borderRadius: "10px",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                color: "white",
                boxShadow: "0 0 10px rgba(0,0,0,0.5)",
                textAlign: "left"
              }}
            >
              <div style={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
                {room.name} {isLocked ? "🔒" : ""}
              </div>
              <div style={{ marginBottom: "0.75rem" }}>
                🟢 {room.online_count || 0} online / 🧍‍♂️ {room.total_count || 0} total
              </div>

                {room.leader && (
                  <div style={{ marginBottom: "0.5rem", fontStyle: "italic", color: "#ccc" }}>
                  🧙 Leader: {room.leader === username ? "You" : room.leader}
                  </div>
                )}

              <button
                onClick={() => handleJoin(room.name)}
                disabled={disabled}
                title={
                  blockedFromGuildhall
                    ? "Founders only. Guildhall access denied."
                    : isLocked
                    ? "Room is locked"
                    : "Join this room"
                }
                style={{
                  padding: "0.5rem 1rem",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: disabled ? "#777" : "#4b2e83",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: disabled ? "not-allowed" : "pointer",
                  boxShadow: "0 0 5px rgba(0,0,0,0.3)"
                }}
              >
                {blockedFromGuildhall ? "🚫 No Entry" : "Join Room"}
              </button>
            </li>
          );
        })}
      </ul>

      <p style={{ color: "white", marginTop: "1rem" }}>{message}</p>
    </div>
  );
}

export default RoomSelection;
